import { Camera } from '@capacitor/camera';
import { notAvailable } from './util/models';
import { isFeatureAvailable, featureNotAvailableError } from './util/feature-check';
import { useState } from 'react';
import { Capacitor } from '@capacitor/core';
if (!Capacitor.isPluginAvailable('Camera')) {
    console.warn('The @capacitor/camera plugin was not found, did you forget to install it?');
}
export const availableFeatures = {
    getPhoto: isFeatureAvailable('Camera', 'getPhoto'),
};
export function useCamera() {
    const [photo, setPhoto] = useState();
    if (!availableFeatures.getPhoto) {
        return Object.assign({ getPhoto: featureNotAvailableError }, notAvailable);
    }
    async function getPhoto(options) {
        const cameraPhoto = await Camera.getPhoto(options);
        setPhoto(cameraPhoto);
        return cameraPhoto;
    }
    return {
        photo,
        getPhoto,
        isAvailable: true,
    };
}
//# sourceMappingURL=useCamera.js.map